$(document).ready(function(){


  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });  
  



  $('.mega-menu__link--trigger').click(function(e) {
    $('#megaMenu').slideToggle();
	 $('.site-nav .mega-menu__link .icon-arrow-down').toggleClass('mega-open'); 
  });
  


  $('.mobileNavBar-link').click(function(e) {

    $('.mobile-nav').slideToggle();

  });

	
  $('.fancybox').magnificPopup({
    type:'inline'
  });
  
  $('.fancybox').click(function(e){
    e.stopPropagation();
  	var1 = $(this).attr('class');
    $('#details').removeClass();
    $('#details').addClass(var1).removeClass('fancybox btn');
  });


  $('.test-popup-link').magnificPopup({
    type: 'image'
    // other options
  });


  $('.form-popup').magnificPopup({
    type:'inline',
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });


  $('.simple-ajax-popup-align-top').magnificPopup({
    type: 'ajax',
    alignTop: true,
    overflowY: 'scroll' // as we know that popup content is tall we set scroll overflow by default to avoid jump
  });

  $('.simple-ajax-popup').magnificPopup({
    type: 'ajax'
  });





  $(window).scroll(moveFloater).resize(moveFloater);

  function moveFloater() {
    var top = Math.max($(window).scrollTop() + $(window).height() - $('#floatingCTA').outerHeight(true) - 160, 100);
    $('#floatingCTA').css({'top': top + 'px'});
  }

  $(".close-cta").click(function(){
    $('#floatingCTA').css({'display': 'none' });
  });


  $('.flex-carousel').flexslider({
    animation: "slide",
    animationLoop: false,
    itemWidth: 500,
    itemMargin: 15,
    mousewheel: true,
    rtl: true,
    minItems: 1,
    maxItems: 2
  });


  $('.flex-carousel-home').flexslider({
    animation: "slide",
    animationLoop: false,
    itemWidth: 800,
    itemMargin: 15,
    /*mousewheel: true,*/
    rtl: true,
    minItems: 1,
    maxItems: 1
  });

  
  
   
  
  $('#addToCartForm .selector-wrapper').first('select').prepend('<label>Select Plan (Scroll down to compare)</label>');
  $('#addToCartForm .selector-wrapper').next().first('select').prepend('<label>Select users</label>');

  $('#addToCartForm1 .selector-wrapper').first('select').prepend('<label>Select Plan (Scroll down to compare)</label>');
  $('#addToCartForm1 .selector-wrapper').next().first('select').prepend('<label>Number of employees in your business</label>');
  
  $('#addToCartForm2 .selector-wrapper').next().first('select').prepend('<label>Number of employees in your business</label>');
  
 
  // Rescue hub page
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});

});



